module.exports = __webpack_public_path__ + "img/icono.d11af107.png";